import type { IFeatureIslandCategoriesAndManagerStore } from "@/components/features/_layouts/island/main-with-category/store";
import { createFeatureIslandCategoryStore } from "@/components/features/_layouts/island/main-with-category/store/category";
import { createFeatureIslandCategoryManagerStore } from "@/components/features/_layouts/island/main-with-category/store/category-manager";

export class PlanCategoriesAndManagerStore implements IFeatureIslandCategoriesAndManagerStore {
	// 基本設定
	public base = createFeatureIslandCategoryStore({
		title: "プラン名・画像",
		description: "",
		isBasicSetup: true,
	});

	public connection = createFeatureIslandCategoryStore({
		title: "紐付け",
		description: "",
		isBasicSetup: true,
	});

	public priceAndPolicy = createFeatureIslandCategoryStore({
		title: "料金・ポリシー",
		description: "",
		isBasicSetup: true,
	});

	// ここから下は 「追加設定」isBasicSetup: false
	public term = createFeatureIslandCategoryStore({
		title: "販売期間",
		description: "",
		isBasicSetup: false,
	});

	public stock = createFeatureIslandCategoryStore({
		title: "在庫",
		description: "",
		isBasicSetup: false,
	});

	public preQuestions = createFeatureIslandCategoryStore({
		title: "事前質問",
		description: "",
		isBasicSetup: false,
	});

	public email = createFeatureIslandCategoryStore({
		title: "メール",
		description: "",
		isBasicSetup: false,
	});

	public stayLength = createFeatureIslandCategoryStore({
		title: "滞在期間・連泊",
		description: "",
		isBasicSetup: false,
	});

	public planAttributes = createFeatureIslandCategoryStore({
		title: "プラン属性",
		description: "",
		isBasicSetup: false,
	});

	public categoryStoreArray = [
		this.base,
		this.connection,
		this.priceAndPolicy,
		this.term,
		this.stock,
		this.email,
		this.preQuestions,
		this.stayLength,
		this.planAttributes,
	];

	public categoryManagerStore = createFeatureIslandCategoryManagerStore({
		items: this.categoryStoreArray,
	});
}

export const planCategoriesAndManagerStore = new PlanCategoriesAndManagerStore();
